// extracted by mini-css-extract-plugin
module.exports = {"table":"BusinessHoursTable_table_1ccVj"};